import styled from '@emotion/styled'

export const Text = styled('p')(({ customCss }) => ({
  fontSize: '22px',
  fontWeight: 'normal',
  ...customCss,
}))
